import React from 'react'

import FormDrawerWrapper from '../../../../../features/components/FormDrawerWrapper'
import CreatePartnerAccountForm from './CreatePartnerAccountForm'

import { PARTNER_ACCOUNT_CREATE } from '../../../../../constants/forms'

const CreatePartnership = () => {
  return (
    <FormDrawerWrapper
      formName={PARTNER_ACCOUNT_CREATE}
      title="Create a partner account"
      openButtonText="Add a partner account"
    >
      <CreatePartnerAccountForm />
    </FormDrawerWrapper>
  )
}

export default CreatePartnership
